import { Injectable } from '@angular/core';
import { deleteLegacyCookies } from 'projects/lib-shared-common/src/public-api';
import { AuthCognitoService } from './auth-cognito.service';
import { SvcStoredAuthUserService } from './svc-stored-auth-user.service';

export interface AuthSessionCleanupOptions {
  /** localStorage keys prefixed 'Cognito' (Amplify-managed tokens). */
  cognitoTokens?: boolean;
  /** 'authenticatedUserSub' + 'authenticatedUserToken' (also clears via AuthCognitoService, notifying other tabs). */
  authenticatedUserSub?: boolean;
  /** true clears every quick sign-in cached user ('SvcCacheDataUser'); a userId clears only that entry. */
  storedAuthUsers?: boolean | string;
  /** 'accessToken' (dev/feed local sign-in). */
  accessToken?: boolean;
  /** 'expiredToken' flag. */
  expiredTokenFlag?: boolean;
  /** legacy ASP/.NET core session cookies. */
  legacyCookies?: boolean;
  /** 'roles' permission cache. */
  roles?: boolean;
  /** 'environmentUrl' (explicit reset/global sign-in flows only). */
  environmentUrl?: boolean;
}

@Injectable({ providedIn: 'root' })
export class AuthSessionCleanupService {
  constructor(
    private _authCognitoService: AuthCognitoService,
    private _storedAuthUserService: SvcStoredAuthUserService
  ) { }

  clear(options: AuthSessionCleanupOptions): void {
    if (options.cognitoTokens) this.#clearCognitoTokens();
    if (options.authenticatedUserSub) this._authCognitoService.authenticatedUserSub = null;

    if (options.storedAuthUsers === true) this._storedAuthUserService.deleteAllUsers();
    else if (typeof options.storedAuthUsers === 'string') this._storedAuthUserService.removeUserByUserId(options.storedAuthUsers);

    if (options.accessToken) localStorage.removeItem('accessToken');
    if (options.expiredTokenFlag) localStorage.removeItem('expiredToken');
    if (options.legacyCookies) deleteLegacyCookies();
    if (options.roles) localStorage.removeItem('roles');
    if (options.environmentUrl) localStorage.removeItem('environmentUrl');
  }

  #clearCognitoTokens(): void {
    try {
      const keysToRemove = [
        'authenticatedUserSub',
        'authenticatedUserToken',
        'accessToken',
      ];

      Object.keys(localStorage).forEach((key) => {
        if (
          key?.startsWith('Cognito') ||
          key?.startsWith('amplify-') ||
          keysToRemove.includes(key)
        ) {
          localStorage.removeItem(key);
        }
      });

    } catch (e) {
      console.error(e);
    }
  }
}
